import {makeStyles} from "@mui/styles";

const useStyles = makeStyles({
    LayoutBody: {
        // backgroundColor: "red"
    }
});
export default useStyles;